
<template>
  <div class="x-header" :class="isGray ? 'wrapperImg' : ''">
    <div class="container-width">
      <div class="logo">
        <a href="/"
          ><img src="@/assets/image/logo.png" title="中国医科大学附属盛京医院"
        /></a>
        <a
          class="min-email-login"
          href="https://mail.sj-hospital.org"
          target="_blank"
          ><i class="iconfont icon-xinfeng"></i> <span>邮箱登录</span></a
        >
      </div>
      <div class="nav-mod">
        <ul class="">
          <li class="nav-item" v-for="(item, index) in navList" :key="index">
            <div class="nav-tit">
              <a
                @click="handleChangenNav(item, index)"
                :class="index == activeIndex ? 'bold' : ''"
                >{{ item.name }}</a
              >
            </div>
            <ul
              class="nav-lv"
              v-if="item.children && item.children.length && DWIDTH"
            >
              <li v-for="(m, n) in item.children" :key="n">
                <a @click="handleChangenNav(m, index)">{{ m.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
        <div>
          <a
            class="email-login"
            href="https://mail.sj-hospital.org"
            target="_blank"
            ><i class="iconfont icon-xinfeng"></i> <span>邮箱登录</span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from "../service/index";
import { HeaderNavDic } from "../const/navigationData";
export default {
  name: "Header",
  props: {},
  data() {
    return {
      activeIndex: 0,
      navList: HeaderNavDic,
      isGray: false, // 首页是否置灰
      DWIDTH: false,
    };
  },
  methods: {
    handleChangenNav(e, i) {
      this.activeIndex = i;
      this.$router.push(`${e.path}`);
    },
    getList() {
      service.getNavList({}, (res) => {
        if (res.content) {
          if (res.content[0].views == "显示") {
            this.navList.push({
              name: res.content[0].name,
              path: "/nav/one",
              picUrl: "",
            });
          }
          if (res.content[1].views == "显示") {
            this.navList.push({
              name: res.content[1].name,
              path: "/nav/two",
              picUrl: "",
            });
          }
        }
      });
    },
    getGraySetting() {
      service.setIndexGray({}, (res) => {
        this.isGray = res;
      });
    },
  },
  mounted() {
    this.activeIndex = this.$route.meta.activeIndex || 0;
    this.getList();
    this.getGraySetting();
    if (window.screen.width < 720) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.meta.activeIndex || 0;
    },
  },
  destroyed() {
    if (this.timer) {
      // 注意在vue实例销毁前，清除我们的定时器
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped lang="scss">
.isGray {
  -webkit-filter: grayscale(100%);
  filter: Gray;
}
.x-header {
  border-top: 5px solid #00479d;
  width: 100%;
  height: 140px;
  z-index: 4;
  position: relative;
  .logo {
    // height: 100%;
    width: 480px;
    img {
      display: block;
      width: 480px;
    }
  }
  .container-width {
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    height: 140px;
  }
}
.nav-mod {
  display: flex;
}
.nav-mod > ul {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.nav-lv {
  visibility: hidden;
  opacity: 0;
  display: none;
}
.nav-tit a {
  font-size: 1.2rem;
  padding: 35px 20px;
}
.nav-tit a:hover {
  color: #00479d;
  font-weight: bold;
}
.nav-item {
  position: relative;
  cursor: pointer;
}
.nav-item:hover::after,
.cur::after {
  transform: translateX(-50%) translateY(0);
  position: absolute;
  top: 20px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom-color: #00479d;
  content: "";
  transition: width 0.5s;
  left: 50%;
  transform: translateX(-50%) translateY(0.2rem);
  /* opacity: 0; */
  transition: 0.3s;
  color: #00479d;
  font-weight: bold;
}
.nav-item:hover > .nav-lv,
.cur > .nav-lv {
  visibility: visible;
  opacity: 1;
  display: block;
  position: absolute;
  left: 50%;
  margin-left: -105px;
  top: 42px;
  padding: 27px 0;
  background-color: #fff;
  width: 210px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.nav-lv li {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.nav-lv li a {
  font-size: 1.1rem;
  line-height: 40px;
  color: #333;
}
.nav-lv li:hover {
  color: #00479d;
  font-weight: bold;
}
.bold {
  color: #00479d;
  font-weight: bold;
}
.email-login {
  background: #00479d;
  padding: 5px 25px;
  box-sizing: border-box;
  color: #fff;
  border-radius: 5px;
  margin-left: 40px;
  cursor: pointer;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  i {
    font-size: 1.1rem;
    margin-right: 3px;
    margin-top: 2px;
  }
  span {
    font-size: 0.9rem;
  }
}
.min-email-login {
  display: none;
}

@media only screen and (max-width: 720px) {
  .x-header {
    height: 160px;
    .logo {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      img {
        display: block;
        width: 65vw;
      }
      .min-email-login {
        background: #00479d;
        padding: 3px 10px;
        box-sizing: border-box;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        height: 32px;
        i {
          font-size: 12px;
          margin-right: 3px;
          margin-top: 2px;
        }
        span {
          font-size: 0.9rem;
        }
      }
    }
    .container-width {
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      height: 160px;
    }
  }

  .nav-tit a {
    font-size: 1.1rem;
    padding: 3px 5px;
  }
  .email-login {
    display: none;
  }
  .nav-mod {
    width: 100%;
    padding: 0;
  }
  .nav-mod > ul {
    width: 100%;
    border-top: 1px solid #eee;
  }
  .nav-item {
    line-height: 60px;
  }
  .nav-item:hover::after,
  .cur::after {
    display: none;
  }
}
@media only screen and (min-width: 376px) and (max-width: 420px) {
  .x-header {
    height: 160px;
    .logo {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      img {
        display: block;
        width: 65vw;
      }
      .min-email-login {
        background: #00479d;
        padding: 3px 10px;
        box-sizing: border-box;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        height: 32px;
        i {
          font-size: 12px;
          margin-right: 3px;
          margin-top: 2px;
        }
        span {
          font-size: 0.9rem;
        }
      }
    }
    .container-width {
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      height: 160px;
    }
  }

  .nav-tit a {
    font-size: 16px;
    padding: 3px 5px;
  }
  .email-login {
    display: none;
  }
  .nav-mod {
    width: 100%;
    padding: 0;
  }
  .nav-mod > ul {
    width: 100%;
    border-top: 1px solid #eee;
  }
  .nav-item {
    line-height: 60px;
  }
  .nav-item:hover::after,
  .cur::after {
    display: none;
  }
}

@media only screen and (min-width: 721px) and (max-width: 1280px) {
  .x-header {
    height: 220px;

    .container-width {
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      height: 160px;
      align-items: flex-start;
    }
    .logo {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .min-email-login {
        background: #00479d;
        padding: 3px 10px;
        box-sizing: border-box;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        i {
          font-size: 1.1rem;
          margin-right: 3px;
          margin-top: 2px;
        }
        span {
          font-size: 0.9rem;
        }
      }
    }
  }

  .nav-tit a {
    font-size: 1.2rem;
    padding: 3px 5px;
  }
  .email-login {
    display: none;
  }

  .nav-mod {
    width: 100%;
  }
  .nav-mod > ul {
    width: 100%;
    border-top: 1px solid #eee;
  }
  .nav-item {
    line-height: 60px;
  }

  .nav-item:hover::after,
  .cur::after {
    display: none;
  }
}
@media only screen and (min-width: 1280px) {
  .nav-tit a {
    font-size: 1.3rem;
    padding: 35px 20px;
  }
}
@media only screen and (min-width: 1920px) {
  .nav-tit a {
    font-size: 1.6rem;
    padding: 35px 30px;
  }
}
</style>
